<template>
  <div>
    <div class="columns">
      <div class="column">
        <h2 class="title is-3">Лендинги</h2>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <v-text-field
          outlined
          dense
          hide-details
          clearable
          label="Название"
          v-model="params.package_name"
          @click:clear="onClear"
          @input="filterApps"
        />
      </div>
      <div class="column">
        <v-select
          outlined
          dense
          hide-details
          clearable
          :items="profiles"
          item-value="id"
          item-text="name"
          label="Пользователь"
          v-model="params.profile_id"
          @input="filterApps"
        />
      </div>
      <div class="column">
        <v-select
          outlined
          dense
          hide-details
          :items="statuses"
          item-value="value"
          item-text="name"
          label="Статус"
          v-model="params.status"
          @input="filterApps"
        />
      </div>
      <div class="column">
        <b-button
          class="is-pulled-right"
          type="is-primary"
          icon-right="plus"
          @click="create"
        >Добавить</b-button>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <v-select
          outlined
          dense
          hide-details
          clearable
          :items="fieldsSort"
          item-value="value"
          item-text="name"
          label="Сортировка"
          v-model="params.sort"
          @input="filterApps"
        />
      </div>
      <div class="column">
        <v-select
          outlined
          dense
          hide-details
          clearable
          :items="fieldsSortType"
          item-value="value"
          item-text="name"
          label="Направление"
          v-model="params.sort_direction"
          @input="filterApps"
        />
      </div>
      <div class="column">
        <b-button class="text-btn" @click="setDefaultParams">Сбросить параметры</b-button>
      </div>
    </div>

    <!-- ТАБЛИЦА -->
    <b-table
      :data="applications.results"
      paginated
      backend-pagination
      :total="applications.total"
      :per-page="params.perPage"
      @page-change="onPageChange"
      class="users-table"
    >
      <b-table-column
        label="Название"
        v-slot="props"
      >
        <span>{{ props.row.package_name}}-{{props.row.keitaro_id}}({{props.row.landing_name}})</span>
      </b-table-column>

      <b-table-column
        field="phone"
        label="Статус"
        v-slot="props"
      >
        <span>{{ statuses.find(o => o.value === props.row.status).name }}</span>
      </b-table-column>

      <b-table-column
        field="second_name"
        label="Действия"
        v-slot="props"
      >
        <div>
          <b-tooltip label="Редактировать">
            <b-button class="edit_icon" @click="edit(props.row)">
              <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"></path>
                <path d="M13.5 6.5l4 4"></path>
              </svg>
            </b-button>
          </b-tooltip>

          <b-tooltip label="Дублировать">
            <b-button class="edit_icon" @click="openDuplicateModal(props.row)">
              <svg
                viewBox="0 0 800 800"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M308.214 216.929V171.286C308.214 128.253 308.214 106.737 321.583 93.3683C334.952 80 356.468 80 399.5 80H627.714C670.746 80 692.262 80 705.631 93.3683C719 106.737 719 128.253 719 171.286V399.5C719 442.532 719 464.048 705.631 477.417C692.262 490.786 670.746 490.786 627.714 490.786H582.071M171.286 719H399.5C442.532 719 464.048 719 477.417 705.631C490.786 692.262 490.786 670.746 490.786 627.714V399.5C490.786 356.468 490.786 334.952 477.417 321.583C464.048 308.214 442.532 308.214 399.5 308.214H171.286C128.253 308.214 106.737 308.214 93.3683 321.583C80 334.952 80 356.468 80 399.5V627.714C80 670.746 80 692.262 93.3683 705.631C106.737 719 128.253 719 171.286 719Z" stroke-width="50" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </b-button>
          </b-tooltip>

          <b-tooltip label="Удалить">
            <b-button
              class="delete_icon"
              @click="remove(props.row)">
              <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 7l16 0"></path>
                <path d="M10 11l0 6"></path>
                <path d="M14 11l0 6"></path>
                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
              </svg>
            </b-button>
          </b-tooltip>
        </div>
      </b-table-column>

      <!-- Пагинация и выбор количества элементов на странице -->
      <template slot="bottom-left">
        <div class="pagination-controls">
          <v-select
            style="width: fit-content; float: left;"
            v-model="params.perPage"
            @change="filterApps"
            :items="perPageOptions"
            item-text="name"
            item-value="value"
            outlined
            hide-details
            dense
          />
        </div>
      </template>

    </b-table>

    <ConfirmDeletionApplicationModal/>
    <DuplicateLandingModal/>

  </div>
</template>

<script>
import draggable from "vuedraggable";
import ConfirmDeletionApplicationModal
  from "@/app/client/applications/shared/modals/confirmDeletionApplicationModal.vue";
import DuplicateLandingModal from '@/app/client/applications/shared/modals/dublicateApplicationModal.vue';

export default {
  name: "AdminLandingsList",
  components: {
    draggable,
    ConfirmDeletionApplicationModal,
    DuplicateLandingModal
  },
  watch: {
    'params.page'(val) {
      this.$store.commit('SET_APPLICATIONS_PARAMS', { ...this.params });
    },
    'params.perPage'(val) {
      this.$store.commit('SET_APPLICATIONS_PARAMS', { ...this.params });
    },
    'params.sort'(val) {
      this.$store.commit('SET_APPLICATIONS_PARAMS', { ...this.params });
    },
    'params.sort_direction'(val) {
      this.$store.commit('SET_APPLICATIONS_PARAMS', { ...this.params });
    },
    'params.package_name'(val) {
      this.$store.commit('SET_APPLICATIONS_PARAMS', { ...this.params });
    },
    'params.profile_id'(val) {
      this.$store.commit('SET_APPLICATIONS_PARAMS', { ...this.params });
    },
    'params.status'(val) {
      this.$store.commit('SET_APPLICATIONS_PARAMS', { ...this.params });
    },
    isDeletionModalOpen(val) {
      if (!val) {
        this.filterApps();
      }
    },
    isDublicateModalOpen(val) {
      if (!val) {
        this.filterApps();
      }
    }
  },
  data() {
    return {
      statuses: [
        { value: 'active', name: 'Активно' },
        { value: 'block', name: 'Заблокировано' },
        { value: 'moder', name: 'На модерации' },
        { value: 'develop', name: 'В разработке' },
        { value: 'deleted', name: 'Удалено' },
        { value: '', name: 'Все' },
      ],
      fieldsSort: [
        { value: 'id', name: 'Дата создания' },
        { value: 'package_name', name: 'Название' },
        { value: 'updated_at', name: 'Дата изменения' }
      ],
      fieldsSortType: [
        { value: 'ASC', name: 'По возрастанию' },
        { value: 'DESC', name: 'По убыванию' },
      ],
      perPageOptions: [
        { name: "10 на странице", value: 10 },
        { name: "20 на странице", value: 20 },
        { name: "50 на странице", value: 50 },
        { name: "100 на странице", value: 100 },
      ],
    };
  },
  created() {
    this.filterApps();
    this.filterTemplates();
    this.$store.dispatch("GET_PROFILES", { type: 'SET_PROFILES' });
  },
  computed: {
    isDeletionModalOpen: {
      get(){
        return this.$store.getters.IS_APPLICATION_DELETION_MODAL_OPENED;
      },
      set(value){
        this.$store.commit('SET_APPLICATION_DELETION_MODAL_IS_OPENED', value);
      }
    },
    params: {
      get() {
        return this.$store.getters.APPLICATIONS_PARAMS;
      },
      set(value) {
        this.$store.commit('SET_APPLICATIONS_PARAMS', value);
      }
    },
    applications() {
      return this.$store.getters.APPLICATIONS;
    },
    profiles() {
      return this.$store.getters.GET_PROFILES;
    },
    isDublicateModalOpen: {
      get() {
        return this.$store.getters.IS_DUPLICATE_APPLICATION_MODAL_OPENED;
      },
      set(value) {
        this.$store.commit('SET_DUPLICATE_APPLICATION_MODAL_OPENED', value);
      }
    }
  },
  methods: {
    openDuplicateModal(row) {
      // Тянем данные лендинга в currentApplication
      this.$store.dispatch('GET_APPLICATION_BY_ID', row.id).then(() => {
        // Открываем модалку
        this.isDublicateModalOpen = true;
      }).catch(() => {
        this.$toast.error('Не удалось загрузить данные лендинга');
      });
    },
    setDefaultParams() {
      this.$store.commit('SET_APPLICATIONS_PARAMS_DEFAULT');
    },
    onPageChange(page) {
      this.params.page = page;
      this.filterApps();
    },
    edit(application) {
      this.$router.push({ path: `/application/update/${application.id}` }).catch(() => {});
    },
    create() {
      this.$router.push({ path: "/application/create" }).catch(() => {});
    },
    remove(application) {
      this.$store.commit('SET_CURRENT_APPLICATION', application);
      this.isDeletionModalOpen = true;
    },
    onClear() {
      this.params.package_name = '';
      this.filterApps();
    },
    filterApps() {
      this.$store.dispatch("GET_APPLICATIONS", this.params);
    },
    filterTemplates() {
      this.$store.dispatch("GET_TEMPLATES", { type: 'app', all: true });
    },
  },
};
</script>
